// extracted by mini-css-extract-plugin
export default {"truncate":"VideoGrid_truncate__+dE0k","shadow":"VideoGrid_shadow__4Dx3E"};